var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSoeg = function SvgIconSoeg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 13.2c0-5.84 4.8-10.64 10.64-10.64s10.64 4.8 10.64 10.64-4.8 10.64-10.64 10.64S2.8 19.12 2.8 13.2zm28.24 14.32-6.96-6.96c1.44-2.08 2.32-4.64 2.32-7.36C26.4 6.08 20.64.24 13.44.24S.56 6.08.56 13.2s5.76 12.96 12.96 12.96c2.72 0 5.28-.88 7.36-2.32l6.96 6.96c.48.48 1.04.64 1.6.64s1.2-.24 1.6-.64c.88-.88.88-2.32 0-3.28z"
  })));
};
export default SvgIconSoeg;